import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout/layout"
import * as Layout2Col from "../components/layout/layout2col/layout2col"
import Breadcrumbs from "../components/breadcrumbs/breadcrumbs"
import HeroSimple from "../components/hero/heroSimple/heroSimple"
import Seo from "../components/seo/seo"

import ResourceCategories from "../components/resource/resourceCategories/resourceCategories"
import ListItem from "../components/shared/listItem/listItem"
import Pagination from "../components/shared/pagination/pagination"

const ResourceList = ({ data, pageContext }) => {
  const { content, seo } = data.sanityResourceListing.tabs
  const resources = data.allSanityResource
  const { currentPage, totalPages } = pageContext
  const steps = [
    {
      link: `resources`,
      title: "Resources",
    },
  ]

  return (
    <Layout>
      <Seo
        isBlogPost={false}
        title={content.title}
        path={pageContext.path}
        image={content.featuredImage?.asset.url}
        breadcrumbs={steps}
        {...seo}
      />
      <Breadcrumbs steps={steps} />
      <HeroSimple blocks={content.hero[0].children} subtitle={content.subtitle} />
      <Layout2Col.Wrapper>
        <Layout2Col.Main>
          <div className="grid">
            {resources.nodes.map(resource => (
              <ListItem {...resource.tabs.content} base="resources" />
            ))}
          </div>
          {totalPages > 1 && <Pagination base="resources" currentPage={currentPage} totalPages={totalPages} />}
        </Layout2Col.Main>
        <Layout2Col.Sidebar>
          <ResourceCategories />
        </Layout2Col.Sidebar>
      </Layout2Col.Wrapper>
    </Layout>
  )
}

export const query = graphql`
  query($skip: Int!, $limit: Int!) {
    sanityResourceListing {
      tabs {
        content {
          hero: _rawHero
          subtitle
        }
        seo {
          canonical
          description
          metaTitle
          noIndex
          openGraphImage {
            asset {
              url
            }
          }
          removeSitemap
        }
      }
    }
    allSanityResource(sort: { fields: tabs___content___publishDate, order: DESC }, limit: $limit, skip: $skip) {
      nodes {
        tabs {
          content {
            title
            subtitle
            excerpt
            category {
              title
              slug {
                current
              }
            }
            slug {
              current
            }
            featuredImage {
              asset {
                fluid(maxWidth: 580) {
                  ...GatsbySanityImageFluid
                }
              }
            }
          }
        }
      }
    }
  }
`

export default ResourceList
